import { PERMISSION } from "constant";

export const isSuperAdmin = (permissions: PERMISSION[]) => {
    return permissions.indexOf(PERMISSION.SUPER_ADMIN) > -1;
}